'use client';
import FormItem from "@/components/common/Form/Item";
import Paragraph from "@/components/common/Typography/Paragraph";
import Text from "@/components/common/Typography/Text";
import Title from "@/components/common/Typography/Title";
import { useAppDispatch } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { Button, Form, Input, message, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type ForgotPasswordFormProps = {
  onClose?: () => void;
};

const ForgotPasswordForm = ({ onClose }: ForgotPasswordFormProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation()

  const onFinish = async (values: { email: string; sdt: string }) => {
    setLoading(true);
    try {
      await dispatch(
        thunks.reset_password({
          body: {
            TYPE: "JSON",
            // ...values,
            email: values.email,
          },
        })
      );
      toast.success(t("auth.forgot_pass_succeed"));
      form.resetFields();
      if (onClose) {
        onClose();
      }
    } catch (error: any) {
      message.error(error?.message || t("auth.forgot_pass_failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      layout="vertical"
      className="form-login"
      form={form}
      onFinish={onFinish}
    >
      <Title level={2} style={{ textAlign: "center", marginTop: 0 }}>
        {t("auth.forgot_password_title")}
      </Title>
      <Paragraph style={{ textAlign: "center" }}>
        {t("auth.forgot_password_desc")}
      </Paragraph>
      <FormItem
        name="email"
        rules={[
          { required: true, message: t("booking.email_input_required_message") },
          { type: "email", message: t("booking.email_input_rule_message") },
        ]}
      >
        <Input type="email" size="large" placeholder={t("booking.email_input_placeholder")} />
      </FormItem>
      <FormItem
        name="sdt"
        rules={[
          { required: true, message: t("booking.phonenumber_input_required_message") },
        ]}
      >
        <Input size="large" placeholder={t("booking.phonenumber_input_placeholder")} />
      </FormItem>
      <Row justify="end">
        <Button
          size="large"
          loading={loading}
          htmlType="submit"
          type="primary"
          block
        >
          {t("common.continue")}
        </Button>
      </Row>
      <Row justify="center" className="form-login--policy" style={{ marginTop: 20 }}>
        <Text>
          {t("auth.forgot_password_note")}
        </Text>
      </Row>
    </Form>
  );
};

export default ForgotPasswordForm;